import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import {
  createAutocompleteField,
  createDateField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum PayoutsFilterKeys {
  mall = "mall",
  brand = "brand",
  generatedAt = "generatedAt",
  coverageDate = "coverageDate"
}

export interface PayoutsListFilterOpts {
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
  brand: FilterOpts<string[]> & AutocompleteFilterOpts;
  generatedAt: FilterOpts<MinMax>;
  coverageDate: FilterOpts<MinMax>;
}

const messages = defineMessages({
  brand: {
    defaultMessage: "Brand",
    description: "brand name"
  },
  coverageDate: {
    defaultMessage: "Coverage",
    description: "coverage date"
  },
  generatedAt: {
    defaultMessage: "Date Generated",
    description: "date generated"
  },
  mall: {
    defaultMessage: "Mall",
    description: "mall branch"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: PayoutsListFilterOpts
): IFilter<PayoutsFilterKeys> {
  return [
    {
      ...createAutocompleteField(
        PayoutsFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    },
    {
      ...createDateField(
        PayoutsFilterKeys.generatedAt,
        intl.formatMessage(messages.generatedAt),
        opts.generatedAt.value
      ),
      active: opts.generatedAt.active
    },
    {
      ...createDateField(
        PayoutsFilterKeys.coverageDate,
        intl.formatMessage(messages.coverageDate),
        opts.coverageDate.value
      ),
      active: opts.coverageDate.active
    },
    {
      ...createAutocompleteField(
        PayoutsFilterKeys.brand,
        intl.formatMessage(messages.brand),
        opts.brand.value,
        opts.brand.displayValues,
        true,
        opts.brand.choices,
        {
          hasMore: opts.brand.hasMore,
          initialSearch: "",
          loading: opts.brand.loading,
          onFetchMore: opts.brand.onFetchMore,
          onSearchChange: opts.brand.onSearchChange
        }
      ),
      active: opts.brand.active
    }
  ];
}
